module.exports = __webpack_public_path__ + "static/HomeHeader-df9755ea236cf55439a8ae4a21be59c7.jpg";